import UpdoxApi from './updoxapi';

const headers = { 'Content-Type': 'application/json' };

const getAppointmentMessageRecipients = (successCallback, errorCallback) =>
  UpdoxApi.getApi(
    'api/appointments/message/possible-recipients',
    headers,
    successCallback,
    errorCallback,
  );

const getUpcomingAppointments = (successCallback, errorCallback) =>
  UpdoxApi.getApi(
    '/api/appointments/list/upcoming',
    headers,
    successCallback,
    errorCallback,
  );

const getPastAppointments = (successCallback, errorCallback) =>
  UpdoxApi.getApi(
    '/api/appointments/list/past',
    headers,
    successCallback,
    errorCallback,
  );

const getFilterLabels = (successCallback, errorCallback) =>
  UpdoxApi.getApi(
    '/api/scheduling/filters/labels',
    headers,
    successCallback,
    errorCallback,
  );

const getDefaultEmailRecipient = (successCallback, errorCallback) =>
  UpdoxApi.getApi(
    '/api/appointments/default-email',
    headers,
    successCallback,
    errorCallback,
  );

const getFilter = (data, successCallback, errorCallback) =>
  UpdoxApi.postApi(
    '/api/scheduling/filter',
    headers,
    JSON.stringify(data),
    successCallback,
    errorCallback,
  );

const getAppointmentTimeRange = (data, successCallback, errorCallback) =>
    UpdoxApi.postApi(
        '/api/scheduling/appointmentTimeRange',
        headers,
        JSON.stringify(data),
        successCallback,
        errorCallback,
    );

const getAllSlots = (data, successCallback, errorCallback) =>
  UpdoxApi.postApi(
    '/api/scheduling/slots',
    headers,
    JSON.stringify(data),
    successCallback,
    errorCallback,
  );

const requestAppointment = (data, successCallback, errorCallback) =>
  UpdoxApi.postApi(
    '/api/scheduling/request',
    headers,
    JSON.stringify(data),
    successCallback,
    errorCallback,
  );

const confirmAppointment = (data, successCallback, errorCallback) =>
  UpdoxApi.postApi(
    '/api/appointments/confirm',
    headers,
    JSON.stringify(data),
    successCallback,
    errorCallback,
  );

const cancelAppointment = (data, successCallback, errorCallback) =>
  UpdoxApi.postApi(
    '/api/appointments/cancel',
    headers,
    JSON.stringify(data),
    successCallback,
    errorCallback,
  );

const sendAppointmentMessage = (data, successCallback, errorCallback) =>
  UpdoxApi.postApi(
    '/api/appointments/message/send',
    headers,
    JSON.stringify(data),
    successCallback,
    errorCallback,
  );

const emailAppointment = (data, successCallback, errorCallback) =>
  UpdoxApi.postApi(
    '/api/appointments/email',
    headers,
    JSON.stringify(data),
    successCallback,
    errorCallback,
  );

const AppointmentsApi = {
    getAppointmentMessageRecipients,
    getUpcomingAppointments,
    getPastAppointments,
    getFilterLabels,
    getDefaultEmailRecipient,
    getFilter,
    getAllSlots,
    getAppointmentTimeRange,
    requestAppointment,
    confirmAppointment,
    cancelAppointment,
    sendAppointmentMessage,
    emailAppointment,
};

export default AppointmentsApi;



// WEBPACK FOOTER //
// ./src/apis/appointments.js